// Import Swiper bundle with all modules installed
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, Manipulation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
window.SwiperNavigation = Navigation
window.SwiperPagination = Pagination
window.SwiperAutoplay = Autoplay
window.SwiperManipulation = Manipulation
window.Swiper = Swiper
